import { render, staticRenderFns } from "./voice_video.vue?vue&type=template&id=03add538&scoped=true"
import script from "./voice_video.vue?vue&type=script&lang=ts"
export * from "./voice_video.vue?vue&type=script&lang=ts"
import style0 from "./voice_video.vue?vue&type=style&index=0&id=03add538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03add538",
  null
  
)

export default component.exports